import React from "react"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { Link } from "react-router-dom"

const SocialSource = () => {

  const socials = [
    {
      title: "Facebook",
      bgColor: "bg-primary",
      iconClass: "mdi-facebook",
      description: "125",
    },
    {
      title: "Twitter",
      bgColor: "bg-info",
      iconClass: "mdi-twitter",
      description: "112",
    },
    {
      title: "Instagram",
      bgColor: "bg-pink",
      iconClass: "mdi-instagram",
      description: "104",
    },
  ];

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4">Need support?</CardTitle>
          <div className="text-center">
            
            <p className="text-muted" style={{textAlign:'left'}}>
            <strong>Get in touch with us on:</strong> 
            </p>
            <p className="text-muted" style={{textAlign:'left'}}>
            <strong>  Email:</strong>  customerservice@definiteassurance.com
            </p>
            <p className="text-muted" style={{textAlign:'left'}}>
            <strong> Phone:</strong>  0708247247
            </p>
            <img src="/support.png" alt="" style={{width:'150px', height:'157px',objectFit:'cover'}} />
          </div>
        
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default SocialSource
